// extracted by mini-css-extract-plugin
export default {"accountCreated":"SignUpSuccess_accountCreated__7TqRJ","primaryButton":"SignUpSuccess_primaryButton__w7GAH"};